export const returnProfileTablist = () => [
  {
    tabName: 'status',
    message: {
      title: 'profile.status',
      comment: '',
      isCommentLocalization: true,
    },
    filterName: 'none',
  },
  {
    tabName: 'financialTransactions',
    message: {
      title: 'booking.fromwallet',
      comment: '',
      isCommentLocalization: false,
    },
    filterName: 'wallet',
  },
  {
    tabName: 'financialTransactions',
    message: {
      title: 'profilecredit.credit',
      comment: '',
      isCommentLocalization: false,
    },
    filterName: 'credit',
  },
];
export const returnEmployeeTabList = () => [
  {
    tabName: 'employeeList',
    message: {
      title: 'profile.employee',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: `col-4 px-0 `,
  },
  {
    tabName: 'addEmployee',
    message: {
      title: 'profile.add',
      comment: 'profile.employee',
      isCommentLocalization: true,
    },
    containerClass: `col-4  px-0 `,
  },
  {
    tabName: 'inviteemployee',
    message: {
      title: 'profile.Invite',
      comment: 'profile.employee',
      isCommentLocalization: true,
    },
    containerClass: ` col-4 px-0`,
  },
];
export const returnCommissionTabList = () => [
  {
    tabName: 'mypoint',
    message: {
      title: 'profile.Services',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ' col-4 p-0 d-flex flex-row justify-content-center',
  },
  {
    tabName: 'pointtransaction',
    message: {
      title: 'profile.transactions',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ' col-4 p-0 d-flex flex-row justify-content-center',
  },
  {
    tabName: 'message',

    message: {
      title: 'profile.messages',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ' col-4 p-0 d-flex flex-row justify-content-center',
  },
];

export const returnCustomerTabList = () => [
  {
    tabName: 'customerList',
    message: {
      title: 'profile.customer',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0',
  },
  {
    tabName: 'addCustomer',
    message: {
      title: 'profile.add',
      comment: 'profile.customer',
      isCommentLocalization: true,
    },
    containerClass: 'col-4 px-0',
  },
  {
    tabName: 'listOfPassengers',
    message: {
      title: 'profile.passengers',
      comment: 'profile.listOfPassengers',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0',
  },
];
export const returnDashboardTabList = () => [
  {
    tabName: 'issued',
    message: {
      title: 'profile.transactions',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: `   `,
  },
  {
    tabName: 'reserve',
    message: {
      title: 'profile.reservations',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ` `,
  },
  {
    tabName: 'expired',
    message: {
      title: 'booking.search',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ``,
    tabClassName: 'cursor-disable text-white bg-third',
    textColor: 'text-white',
  },
];
export const returnFinancialTabList = () => [
  {
    tabName: 'financialTransactions',
    message: {
      title: 'profile.Transactions',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass:
      'col-4 p-0 d-flex flex-row justify-content-center justify-content-center',
  },
  {
    tabName: 'financialInvoices',
    message: {
      title: 'profile.Invoices',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass:
      'col-4 p-0 d-flex flex-row justify-content-center justify-content-center',
  },
  {
    tabName: 'financialPoint',
    message: {
      title: 'profile.point',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass:
      'col-4 p-0 d-flex flex-row justify-content-center justify-content-center',
  },
];
export const returnBookingTabList = () => [
  {
    tabName: 'issued',
    message: {
      title: '',
      comment: '',
      /* {reserveList && reserveList[0] && reserveList[0].totalCount
                          ? numberWithCommas(reserveList[0].totalCount)
                          : 0} */
      isCommentLocalization: false,
      isTitleLocalization: false,
    },
    containerClass: 'col-4 p-0 d-flex flex-row justify-content-center',
  },
  {
    tabName: 'reserve',

    message: {
      title: '',
      comment: '',
      isCommentLocalization: false,
      isTitleLocalization: false,
    },
    containerClass: 'col-4 p-0 d-flex flex-row justify-content-center',
  },
  {
    tabName: 'expired',
    message: {
      title: '',
      comment: '',
      isTitleLocalization: false,
      isCommentLocalization: false,
    },
    containerClass: 'col-4 p-0 d-flex flex-row justify-content-center',
  },
];
export const returnUserBasicInfo = () => [
  {
    tabName: 'myProfile',
    message: {
      title: 'profile.myprofile',
      comment: 'profile.profileedit',
      isCommentLocalization: true,
    },
    containerClass: 'col-4 p-0',
  },
  {
    tabName: 'myFriends',
    message: {
      title: 'profile.myfriends',
      comment: 'profile.addfriend',
      isCommentLocalization: true,
    },
    containerClass: `col-4 p-0`,
  },
  {
    tabName: 'inviteFriend',

    message: {
      title: 'profile.inveitefriend',
      comment: 'profile.sendingInvitation',
      isCommentLocalization: true,
    },
    containerClass: 'col-4 p-0',
  },
];
export const returnTicketTabList = () => [
  {
    tabName: 'inprogress',
    message: {
      title: 'ticket.inprogress',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0',
  },
  {
    tabName: 'done',
    message: {
      title: 'ticket.done',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0 ',
  },
  {
    tabName: 'addNewTicket',
    message: {
      title: 'ticket.new',
      comment: '',
      isCommentLocalization: true,
    },
    containerClass: ' col-4 px-0',
  },
];

export const returnGatewayTabList = () => [
  {
    tabName: 'gatewaylist',
    message: {
      title: 'profile.gatewayroutes',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ``,
  },
  {
    tabName: 'addgateway',
    message: {
      title: 'profile.addgateway',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ` `,
  },
  {
    tabName: 'expired',
    message: {
      title: 'booking.baggagerules',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: ``,
    tabClassName: `cursor-disable text-white bg-third`,
    textColor: 'text-white',
  },
];
